const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigicertName(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 84 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.89,13.53c0-1.5.41-2.72,1.21-3.63.77-.9,1.92-1.41,3.11-1.37.4,0,.77.05,1.15.15.31.08.58.2.85.38.2.14.38.29.55.46.13.11.24.24.34.38l.08.15h.04c-.03-.22-.04-.44-.04-.63v-4.42h1.82v13.31h-1.74v-.9l.02-.63h-.04s-.06.12-.11.19c-.1.15-.21.3-.33.43-.17.21-.38.39-.58.54-.28.19-.57.34-.9.43-.4.13-.81.2-1.23.19-1.18.04-2.31-.48-3.05-1.38-.75-.93-1.14-2.12-1.14-3.62ZM2.75,13.53c0,1.03.25,1.85.74,2.48.47.6,1.19.95,1.95.93.74,0,1.46-.31,1.96-.85.53-.56.79-1.44.79-2.58.02-.85-.23-1.69-.7-2.41-.45-.65-1.2-1.04-1.99-1.01-.75,0-1.48.33-1.96.91-.53.6-.79,1.45-.79,2.51h0v.02Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.53,6.85v-1.86h1.84v1.86h-1.84ZM11.55,18.29v-9.54h1.83v9.54h-1.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.16,20.02c.8.44,1.7.64,2.62.63.9,0,1.63-.22,2.19-.64s.83-1.11.83-2.03v-.69l.02-.59h-.04c-.58.99-1.54,1.49-2.83,1.49-1.2.05-2.35-.48-3.1-1.39-.77-.92-1.16-2.09-1.16-3.48s.38-2.55,1.11-3.44c.74-.89,1.75-1.35,3.06-1.35.41,0,.79.04,1.19.14.31.07.59.19.86.36.2.13.38.28.55.43.12.1.23.23.31.37l.1.13h.04c0-.1-.02-.2,0-.3v-.88h1.75v9.15c.02.68-.12,1.38-.41,2-.25.54-.62,1.01-1.11,1.36-.47.34-.98.58-1.53.74-.57.17-1.18.26-1.77.25-1.14,0-2.26-.27-3.27-.78l.59-1.44v-.02ZM19.33,16.6c.68.02,1.36-.27,1.81-.77.47-.51.69-1.36.69-2.52,0-2.14-.9-3.21-2.71-3.21-.73-.04-1.45.28-1.91.84-.47.56-.68,1.34-.67,2.32,0,1,.25,1.81.74,2.42.49.61,1.25.96,2.03.92h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.13,6.85v-1.86h1.84v1.86h-1.84ZM25.15,18.29v-9.54h1.82v9.54h-1.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.32,13.53c-.03-1.34.49-2.63,1.45-3.56.96-.96,2.19-1.44,3.67-1.44.66,0,1.33.11,1.95.35.47.16.89.4,1.28.7l.37.34-.87,1.29c-.08-.08-.19-.18-.34-.31-.28-.2-.57-.37-.9-.49-.45-.2-.92-.31-1.41-.31-.89-.03-1.75.33-2.38.96-.62.64-.97,1.53-.94,2.43-.03.91.32,1.79.94,2.45.63.65,1.51,1.01,2.42.98.53,0,1.05-.11,1.53-.33.4-.16.75-.38,1.08-.63l.35-.33.72,1.34-.16.16c-.38.34-.78.6-1.24.82-.35.16-.69.28-1.07.38-.45.12-.89.18-1.36.17-1.49,0-2.72-.48-3.68-1.42-.94-.94-1.46-2.23-1.42-3.56h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.47,13.53c0-1.49.46-2.7,1.36-3.61s2.14-1.42,3.42-1.38c1.3,0,2.31.43,3.03,1.27s1.1,1.91,1.1,3.21l-.06.79h-6.97c.05,1,.39,1.78,1.01,2.33.63.54,1.46.83,2.29.8.49,0,.98-.1,1.45-.29.38-.14.71-.33,1.04-.55l.35-.29.75,1.34c-.14.14-.3.27-.46.38-.41.25-.82.46-1.27.6-.62.25-1.31.38-1.98.38-1.48,0-2.7-.48-3.64-1.43-.94-.94-1.46-2.23-1.43-3.56h0ZM39.41,12.42h5.09c-.03-.79-.26-1.4-.68-1.8-.44-.43-1.01-.64-1.62-.63-.66-.02-1.33.22-1.84.63-.52.47-.86,1.1-.94,1.78v.02h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.69,18.29v-9.54h1.77v1.66l-.04.71h.04c.21-.69.59-1.32,1.14-1.79.52-.47,1.19-.7,1.87-.69l.48.04v1.8c-.18-.04-.36-.06-.53-.06-.59,0-1.17.22-1.62.6-.51.44-.87,1-1.05,1.64-.16.56-.24,1.14-.23,1.71v3.9h-1.83v.02Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.29,14.8v-4.45h-1.25v-1.47h1.31v-2.76h1.77v2.76h2.3v1.47h-2.3v4.25c0,.33.05.64.15.95.08.24.21.46.38.62.15.15.32.28.51.36.17.08.35.14.53.17.16.02.33.04.49.04l.44-.04v1.62c-.22.03-.43.04-.63.04-.3,0-.57-.02-.86-.06-.33-.05-.64-.15-.94-.29-.34-.14-.64-.35-.91-.59-.3-.3-.52-.65-.65-1.05-.2-.51-.29-1.04-.29-1.59v.02h-.02Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6,4.95c-.76,0-1.39.61-1.39,1.39s.61,1.39,1.39,1.39,1.38-.61,1.39-1.39c0-.76-.61-1.39-1.39-1.39h0M60.6,7.44c-.61,0-1.12-.5-1.12-1.11s.5-1.12,1.11-1.12,1.12.5,1.12,1.11h0c0,.61-.5,1.11-1.11,1.11h0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.13,7.1v-1.54h.48c.1,0,.2,0,.29.03.08.03.15.08.19.16.05.08.07.17.07.26s-.02.19-.08.26c-.05.07-.12.13-.2.16h0s.03.05.05.07l.33.58h-.25l-.33-.6h-.33v.6h-.22s0,.02,0,.02ZM60.35,6.31h.32c.07,0,.15-.02.2-.08.05-.06.08-.13.07-.21,0-.09-.04-.18-.12-.23-.07-.03-.14-.04-.21-.04h-.25v.54h0v.02Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigicertName);
export default __webpack_public_path__ + "static/media/digicert-name.f80e5c3acc76cface9c8627850d59cb6.svg";
export { ForwardRef as ReactComponent };